module.exports = __webpack_public_path__ + "static/media/banner-default.7e876d5d.png";